export const HOME_ROUTE_NAME = 'HOME_ROUTE_NAME';
